// extracted by mini-css-extract-plugin
module.exports = {"gdprMessage":"gdprMessage___2thnR","title":"title___1IHIp","close":"close___2HO61","content":"content___3Z1bD","btnAccept":"btnAccept___3TbrY"};